import './App.css';
import logo2 from './Maxi.jpg';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Checkout from "./components/Checkout";
import Checkout2 from "./components/Checkout2";
import Checkout3 from "./components/Checkout3";
import Checkout4 from "./components/DeliveryMode";
import Ck4 from "./components/Ck4";
import Confirmation from "./pages/Confirmation";
import Cgv from "./pages/Cgv";
import Confidentialite from "./pages/Confidentialite";
import Mentions from "./pages/Mentions";
import { Link } from "react-router-dom";
import Commandes from "./pages/Commandes";
import "./components/Checkout.css";

function App() {
  return (
    <div className="page-container">
    <div className="App">
      <header className="">
      <a href="/">

</a>
      </header>

      <Router>
        <Routes>
          <Route path="/" element={<Ck4 />} />
          <Route path="/2" element={<Checkout2 />} />
          <Route path="/3" element={<Checkout3 />} />
          <Route path="/4" element={<Checkout4 />} />
          <Route path="/5" element={<Checkout />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/cgv" element={<Cgv />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/mentions-legales" element={<Mentions />} />
          <Route path="/commandes" element={<Commandes />} />
        </Routes>

        <footer className="footer-links">
  <Link to="/cgv">CGV</Link> |{" "}
  <Link to="/confidentialite">Confidentialité</Link> |{" "}
  <Link to="/mentions-legales">Mentions légales</Link> |{" "}
  <Link to="/commandes">Mes commandes</Link>
</footer>
      </Router>

     

      
    </div>
     </div>
  );
}

export default App;
